import { AbstractCommand } from './AbstractCommand';
import { CommandResponse } from '../types';
import { getSequenceId } from '../utils/sequenceIdManager';

export class AbortTaskCommand extends AbstractCommand {
  public readonly category = 'print';
  public readonly command = 'stop' as const;

  constructor() {
    super();
  }

  toJSON(): object {
    return {
      print: {
        command: 'stop',
        sequence_id: getSequenceId().toString(),
        param: ''
      }
    };
  }

  ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
    if (!('print' in response)) {
      return false;
    }

    const printResponse = response as { print: { sequence_id?: string | undefined } };
    const responseId = printResponse.print?.sequence_id;
    const extraId = this.extra?.sequence_id;

    if (!responseId) {
      return false;
    }

    if (sequence_id && responseId === sequence_id) {
      return true;
    }

    if (extraId && responseId === extraId) {
      return true;
    }

    return false;
  }
}